import { render } from "./TirePackage.vue?vue&type=template&id=ee6125ce&scoped=true"
import script from "./TirePackage.vue?vue&type=script&lang=js"
export * from "./TirePackage.vue?vue&type=script&lang=js"

import "./TirePackage.vue?vue&type=style&index=0&id=ee6125ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee6125ce"]])

export default __exports__